import { AlertTriangle, User } from 'lucide-react';

interface UserMenuErrorFallbackProps {
  onRetry?: () => void;
}

export function UserMenuErrorFallback({ onRetry }: UserMenuErrorFallbackProps) {
  return (
    <div className="flex items-center gap-2 p-2 bg-red-50 border border-red-200 rounded-lg">
      <div className="relative">
        <User className="h-6 w-6 text-red-300" />
        <AlertTriangle className="h-3 w-3 text-red-500 absolute -top-0.5 -right-0.5 bg-red-50 rounded-full" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-red-700 truncate">Menu error</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-xs text-red-600 hover:text-red-800 focus:outline-none px-2 py-1 rounded hover:bg-red-100"
        >
          Retry
        </button>
      )}
    </div>
  );
}
